import * as Sentry from "@sentry/react";
import { CaptureConsole } from "@sentry/integrations";
import { useCookieConsent } from "../CookieConsentProvider";

export default function initSentry(allow: boolean) {
  if (!allow) return;
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DNS,
    integrations: [
      new Sentry.BrowserTracing(),
      new Sentry.Replay(),
      new CaptureConsole({ levels: ["error"] })
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      process.env.REACT_APP_SENTRY_DOMAIN || "",
      process.env.REACT_APP_API_URL || ""
    ].filter(Boolean),
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}

export const useSentry = () => {
  const { sentry } = useCookieConsent();

  return {
    captureMessage: (...args: Parameters<typeof Sentry.captureMessage>) => {
      if (!sentry) return "";
      return Sentry.captureMessage(...args);
    }
  };
};
